<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useRealEstateBrokerOnboarding } from '../composables/useRealEstateBrokerOnboarding';
import RealEstateBrokerOnboarding from './RealEstateBrokerOnboarding.vue';

const route = useRoute();
const currentUser = useMapGetter('getCurrentUser');
const accountId = computed(() => route.params.accountId);
const userId = computed(() => currentUser.value?.id);
const { dismiss, isVisible } = useRealEstateBrokerOnboarding({
  accountId,
  userId,
});
</script>

<template>
  <template v-if="isVisible">
    <RealEstateBrokerOnboarding @complete="dismiss" />
  </template>
  <template v-else>
    <span aria-hidden="true" class="hidden" />
  </template>
</template>
